import { LogLevel } from '@genesislcap/foundation-logger';
/**
 * ErrorBuilder to build ErrorStructure
 * @public
 */
export class ErrorBuilder {
    /**
     * Add title to error
     * @public
     * @param title - string
     * @returns
     */
    withTitle(title) {
        this.title = title;
        return this;
    }
    /**
     * Add error details to error
     * @public
     * @param errorDetails - string
     * @returns
     */
    withErrorDetails(errorDetails) {
        this.errorDetails = errorDetails;
        return this;
    }
    /**
     * Add log level to error
     * @public
     * @returns
     */
    withLogLevel(logLevel) {
        this.logLevel = logLevel;
        return this;
    }
    /**
     * Add alert to error
     * @public
     * @param alert - boolean
     * @returns
     */
    withAlert(alert) {
        this.alert = alert;
        return this;
    }
    /**
     * Add notification to error
     * @public
     * @param notification - {@link ErrorNotification}
     * @returns
     */
    withNotification(notification) {
        this.notification = notification;
        return this;
    }
    /**
     * Add banner to error
     * @public
     * @param banner - {@link ErrorBanner}
     * @returns
     */
    withBanner(banner) {
        this.banner = banner;
        return this;
    }
    /**
     * Add snackbar to error
     * @public
     * @param snackbar - {@link Snackbar}
     * @returns
     */
    withSnackbar(snackbar) {
        this.snackbar = snackbar;
        return this;
    }
    /**
     * Add dialog to error
     * @public
     * @param dialog - {@link ErrorDialog}
     * @returns
     */
    withDialog(dialog) {
        this.dialog = dialog;
        return this;
    }
    /**
     * Build ErrorStructure
     * @public
     * @returns
     */
    build() {
        if (!this.title) {
            throw new Error('Title is required');
        }
        if (!this.errorDetails) {
            throw new Error(`Missing required param 'errorDetails'`);
        }
        let errorStructure = {
            title: this.title,
            errorDetails: this.errorDetails,
        };
        let config = {};
        if (this.logLevel in LogLevel) {
            errorStructure = Object.assign({ logLevel: this.logLevel }, errorStructure);
        }
        if (this.alert) {
            config = Object.assign({ alert: this.alert }, config);
            errorStructure = Object.assign({ config }, errorStructure);
        }
        if (this.notification) {
            config = Object.assign({ notification: this.notification }, config);
            errorStructure = Object.assign({ config }, errorStructure);
        }
        if (this.banner) {
            config = Object.assign({ banner: this.banner }, config);
            errorStructure = Object.assign({ config }, errorStructure);
        }
        if (this.snackbar) {
            config = Object.assign({ snackbar: this.snackbar }, config);
            errorStructure = Object.assign({ config }, errorStructure);
        }
        if (this.dialog) {
            config = Object.assign({ dialog: this.dialog }, config);
            errorStructure = Object.assign({ config }, errorStructure);
        }
        return errorStructure;
    }
}
/**
 * Returns a new ErrorBuilder instance
 * @public
 */
export const getErrorBuilder = () => new ErrorBuilder();
